import {
  AlertCircle,
  ListItem,
  ListItemLabel,
  Tag,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectDepositById,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"

type DepositAutoMigrationStateProps = {
  depositUuid: string
  isDisabled?: boolean
}

export default function DepositAutoMigrationState({
  depositUuid,
  isDisabled,
}: DepositAutoMigrationStateProps) {
  const [_, theme] = useStyletron()
  const dispatch = useDappDispatch()

  const deposit = useDappSelector((state) =>
    selectDepositById(state, depositUuid),
  )

  const isAutoMigrationEnabled = deposit?.isAutoMigrationEnabled

  const tagLabel = isAutoMigrationEnabled ? " On" : "Off"

  return (
    <ListItem
      artwork={() => (
        <AlertCircle
          color={theme.colors.contentPrimary}
          size={theme.sizing.scale600}
        />
      )}
      endEnhancer={() => (
        <Tag
          disabled={isDisabled}
          closeable={false}
          onClick={() => {
            dispatch(
              setOpenModal("migrate-to-mainnet", {
                depositUuid,
              }),
            )
          }}
        >
          {isDisabled ? "Disabled" : tagLabel}
        </Tag>
      )}
    >
      <ListItemLabel>Auto-bridge to mainnet</ListItemLabel>
    </ListItem>
  )
}
